import React from 'react'
import BaseLogo from './base-logo.component'

export const Super2000Logo = ({ fontSize }) => (
	<BaseLogo fontSize={fontSize}>
		<div className="name">super</div>
		<div className="points orange">2000</div>
	</BaseLogo>
)
